import type { Context } from './asyncHelpers'
import { fixStack, getDuration } from './asyncHelpers'
import { type Request, RequestError } from './RequestError'

export type Retries = {
	/** Seconds since first request was initiated */
	duration: number
	/** Total retries performed before throwing */
	attempts: number
	/** Messages from all attempts */
	errorMessages: Array<string>
}

export class ApiError extends RequestError {
	public retries: Retries

	protected constructor(
		message: string,
		correlationId: string,
		request: Request,
		retries: Retries,
		data?: Record<string, any>,
	) {
		super(message, correlationId, request, { ...data, retries })
		this.retries = retries
	}

	public static fromRequestError({
		error,
		attempts,
		context: { startTime, stackReference },
		errorMessages,
	}: {
		error: RequestError
		attempts: number
		context: Context<null>
		errorMessages: Array<string>
	}) {
		return fixStack(
			stackReference,
			new ApiError(error.message, error.correlationId, error.request, {
				duration: getDuration(startTime),
				attempts,
				errorMessages,
			}),
		)
	}
}
